import React from "react";
import * as THREE from "three";
import { useSelector, useDispatch } from "react-redux";
import {
  getClickedRoomColor,
  getRangeModeDisplayColor,
  resolveColorbarSettings,
  roomEnergyDataScale,
  getPolygonCentroid,
} from "../utils";
import { ValueLabelsGroup } from "./ValueLabelsGroup";
import { HEATMAP_LABEL_LAYER } from "./heatmapLabelLayers";

import { roomConfigurationStateChanger } from "../../redux/roomData";
import {
  roomGeneralSetTrue,
  updateRoomConfigurationPosition,
} from "../../redux/windowConfiguration";
import { Edges } from "@react-three/drei";
import { isOptionSelected } from "../utility/helpers";
import { reduxLocalStorage } from "../utility/storage";
function genratePolygon(data) {
  var output = [];
  data.forEach((k) => {
    output.push(new THREE.Vector3(k[0], k[1], k[2]));
  });
  return output;
}

const RoomEnergyData = () => {
  const dispatch = useDispatch();
  const selectedFloor = useSelector(
    (state) => state.floorVisibility.selectedFloors,
  );

  const minMaxDict = useSelector((state) => state.roomData.rangeValues);
  const haveRange = useSelector((state) => state.roomData.haveRange);
  const getLocalStorageItem = (key) => {
    const item = reduxLocalStorage.getItem(key);
    return item ? item.split(",") : [];
  };

  const scenarioList = getLocalStorageItem("scenario_list");
  let energyValueData = getLocalStorageItem("value_list");

  const selector = useSelector((state) => state.roomData.value);

  const isApiFinished = useSelector((state) => state.roomData.api.isFinished);
  const data = useSelector((state) => state.roomData.api.data);
  if (isApiFinished == true) {
    for (let valueList = 0; valueList < energyValueData.length; valueList++) {
      for (
        let scenarioVal = 0;
        scenarioVal < scenarioList.length;
        scenarioVal++
      ) {
        for (let i = 0; i < data.length; i++) {}
      }
    }
  }
  const colorbars = useSelector((state) => state.colorbars["Energy Data"]);

  var clickedRoomId = useSelector(
    (state) => state.shadingConfigurationWindow.roomId,
  );
  const roomIsClicked = useSelector(
    (store) => store.roomData.roomConfigurationState,
  );
  return (
    <>
      {isApiFinished && haveRange && data?.length > 0 && (
        <>
          {data.map((eachFloor, floorIndex) => {
            if (!Array.isArray(eachFloor)) return;
            return energyValueData.map((value, valueIndex) => {
              const { max, min, rangeMode } = resolveColorbarSettings(
                colorbars[value],
                minMaxDict[value],
              );
              return scenarioList.map((scenario, scenarioIndex) => {
                const isLayerVisible =
                  selectedFloor[floorIndex] &&
                  isOptionSelected({
                    selector,
                    parentName: value,
                    childName: scenario,
                  });
                const getRoomVisible = (room) => {
                  if (!isLayerVisible) return false;

                  let roomEnergyValue;
                  try {
                    roomEnergyValue = JSON.parse(room.values)[0][valueIndex][
                      value
                    ][scenarioIndex];
                  } catch {
                    return false;
                  }

                  const { visible: valueVisible } = getRangeModeDisplayColor(
                    roomEnergyValue,
                    {
                      min,
                      max,
                      rangeMode,
                      colorScale: roomEnergyDataScale,
                    },
                  );

                  return valueVisible;
                };
                const getRoomColor = (room) => {
                  let roomEnergyValue;
                  try {
                    roomEnergyValue = JSON.parse(room.values)[0][valueIndex][
                      value
                    ][scenarioIndex];
                  } catch {
                    return null;
                  }
                  return getRangeModeDisplayColor(roomEnergyValue, {
                    min,
                    max,
                    rangeMode,
                    colorScale: roomEnergyDataScale,
                  }).color;
                };
                return (
                  <group
                    rotation-x={Math.PI * -0.5}
                    key={`${floorIndex}-${valueIndex}-${scenarioIndex}`}
                  >
                    {eachFloor.map((room, roomIndex) => {
                      let roomEnergyValue;
                      try {
                        roomEnergyValue = JSON.parse(room.values)[0][
                          valueIndex
                        ][value][scenarioIndex];
                      } catch {}

                      const isVisible = isLayerVisible;

                      const { visible: valueVisible, color: meshColor } =
                        getRangeModeDisplayColor(roomEnergyValue, {
                          min,
                          max,
                          rangeMode,
                          colorScale: roomEnergyDataScale,
                        });

                      const roomPolygon = JSON.parse(room.room_polygon);
                      const roomZ = JSON.parse(room.coordinates)[2];

                      return (
                        <mesh
                          key={`${floorIndex}-${valueIndex}-${scenarioIndex}-${roomIndex}`}
                          userData={{ excludeFromLabelOcclusion: true }}
                          position={[0, 0, roomZ]}
                          visible={isVisible && valueVisible}
                          onClick={(config) => {
                            if (isVisible) {
                              // dispatch(setEnergyBoxView(true));
                              dispatch(roomConfigurationStateChanger(true));
                              dispatch(
                                updateRoomConfigurationPosition([
                                  config.pageX,
                                  config.pageY,
                                  room.text,
                                  room.id,
                                  room,
                                ]),
                              );
                              dispatch(roomGeneralSetTrue());
                              config.stopPropagation();
                            }
                          }}
                        >
                          <primitive
                            object={
                              new THREE.ShapeGeometry(
                                new THREE.Shape(genratePolygon(roomPolygon)),
                              )
                            }
                            attach={"geometry"}
                          />
                          {roomIsClicked && clickedRoomId === room.id && (
                            <Edges color="#000" />
                          )}

                          <meshBasicMaterial
                            side={THREE.DoubleSide}
                            color={
                              roomIsClicked && clickedRoomId === room.id
                                ? getClickedRoomColor()
                                : meshColor
                            }
                          />
                        </mesh>
                      );
                    })}
                    {isLayerVisible && (
                      <ValueLabelsGroup
                        visible={isLayerVisible}
                        layerKey={HEATMAP_LABEL_LAYER.ENERGY}
                        items={eachFloor}
                        getVisible={getRoomVisible}
                        getPosition={(room) => {
                          const roomPolygon = JSON.parse(room.room_polygon);
                          const [cx, cy] = getPolygonCentroid(roomPolygon);
                          const roomZ = JSON.parse(room.coordinates)[2];
                          return [cx, cy, roomZ];
                        }}
                        getValue={(room) => {
                          try {
                            return JSON.parse(room.values)[0][valueIndex][
                              value
                            ][scenarioIndex];
                          } catch {
                            return null;
                          }
                        }}
                        getLabelPolygon={(room) =>
                          JSON.parse(room.room_polygon)
                        }
                        getColor={getRoomColor}
                      />
                    )}
                  </group>
                );
              });
            });
          })}
        </>
      )}
    </>
  );
};

export default RoomEnergyData;
